import { Routes } from '@angular/router';
import { MainLayoutComponent } from './core/layout/main-layout/main-layout.component';
import { UserAuthenticatedGuard } from './core/guards/user-authenticated.guard';
import { UserHasContextGuard } from './core/guards/user-has-context.guard';
import { CoachOnlyGuard } from './core/guards/coach-only.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./feature/vitrine/vitrine.module').then(m => m.VitrineModule),
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'auth',
        loadChildren: () =>
          import('./feature/auth/auth.module').then(m => m.AuthModule),
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./feature/profile/profile.module').then(m => m.ProfileModule),
      },
      {
        path: 'chat',
        loadChildren: () =>
          import('./feature/conversation/conversation.module').then(
            m => m.ConversationModule
          ),
        canActivate: [UserAuthenticatedGuard, UserHasContextGuard],
      },
      {
        path: 'map',
        loadChildren: () =>
          import('./feature/map/map.module').then(m => m.MapModule),
        canActivate: [UserAuthenticatedGuard, UserHasContextGuard],
      },
      {
        path: 'affinity',
        loadChildren: () =>
          import('./feature/affinity/affinity.module').then(
            m => m.AffinityModule
          ),
        canActivate: [UserAuthenticatedGuard, UserHasContextGuard],
      },
      {
        path: 'home',
        loadChildren: () =>
          import('./feature/home/home.module').then(m => m.HomeModule),
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('./feature/notifications/notifications.module').then(
            m => m.NotificationsModule
          ),
        canActivate: [UserAuthenticatedGuard, UserHasContextGuard],
      },
      {
        path: 'billing',
        loadChildren: () =>
          import('./feature/billing/billing.module').then(m => m.BillingModule),
        canActivate: [
          UserAuthenticatedGuard,
          UserHasContextGuard,
          CoachOnlyGuard,
        ],
      },
    ],
  },
];
